import { render, staticRenderFns } from "./documentsView.vue?vue&type=template&id=0a3680a4&"
import script from "./documentsView.vue?vue&type=script&lang=js&"
export * from "./documentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports